<template>
    <v-card light>
        <v-card-text>
            <v-form ref="mobileVerificationForm" v-model="mobileVerificationFormIsValid">
                <page-heading :text="$t(pageTranslationText.title)"></page-heading>
                <div class="mb-3">
                    {{ $t(pageTranslationText.subtitle) }}
                </div>
                <v-row justify="center" no-gutters>
                    <v-col cols="12" v-if="!isTokenLogin">
                        <country-select :rules="[(val) => !!val || $t('general.input_required')]"
                                        :value="value.country"
                                        @changed="$refs.mobileTextField.focus()"
                                        @input="$emit('country', $event)"
                        ></country-select>
                    </v-col>
                    <v-col cols="12" v-if="!isTokenLogin">
                        <v-text-field :error-messages="errors[0]"
                                      :label="$t('components.verify_mobile.form_body.mobile_text_field_label')"
                                      :prefix="value.country && value.country.mobilecountrycode ? '(+'+value.country.mobilecountrycode+')' : ''"
                                      :rules="[(val) => !!val || $t('general.input_required')]"
                                      :value="value.mobile"
                                      @input="$emit('mobile', $event)"
                                      @keypress="isNumber($event)"
                                      @keyup.enter="emitLogin()"
                                      autocomplete="off"
                                      outlined
                                      ref="mobileTextField"
                        ></v-text-field>
                    </v-col>
                    <v-col class="text-center my-5" cols="12" v-if="isTokenLogin">
                        <small class="error--text mb-2">{{ errors[0] }}</small>
                        <div class="title">{{ $store.state.auth.maskedMobile }}</div>
                        <div class="title">{{ $store.state.auth.maskedEmail }}</div>
                        <v-btn @click="$emit('logout')" class="secondary--text" small text>
                            {{$t('components.verify_mobile.form_body.not_my_details')}}
                        </v-btn>
                    </v-col>
                    <v-col cols="12">
                        <v-radio-group :label="$t('components.verify_mobile.form_body.radio_group_label')"
                                       class="mt-0"
                                       column
                                       dense
                                       hide-details
                                       mandatory
                                       v-model="via"
                        >
                            <v-radio class="mb-0" value="sms" v-if="!isTokenLogin || $store.state.auth.maskedMobile">
                                <template slot="label">
                                    <v-list-item class="pa-0" two-line>
                                        <v-list-item-content class="pa-0">
                                            <v-list-item-title>
                                                {{ $t('components.verify_mobile.form_body.radio_sms_label') }}
                                            </v-list-item-title>
                                            <v-list-item-subtitle class="text-wrap">
                                                {{ $t('components.verify_mobile.form_body.radio_sms_hint') }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-radio>
                          <v-radio class="mb-0" value="whatsapp" v-if="whatsAppEnabled && (!isTokenLogin || $store.state.auth.maskedMobile)">
                            <template slot="label">
                              <v-list-item class="pa-0" two-line>
                                <v-list-item-content class="pa-0">

                                  <v-list-item-title>
                                    {{ $t('components.verify_mobile.form_body.radio_whatsapp_label') }}
                                  </v-list-item-title>
                                  <v-list-item-subtitle class="text-wrap">
                                    {{ $t('components.verify_mobile.form_body.radio_whatsapp_hint') }}
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-avatar><v-icon color="success">mdi-whatsapp</v-icon></v-list-item-avatar>

                              </v-list-item>
                            </template>
                          </v-radio>
                            <v-radio class="mb-0" value="call" v-if="!isTokenLogin || $store.state.auth.maskedMobile">
                                <template slot="label">
                                    <v-list-item class="pa-0" two-line>
                                        <v-list-item-content class="pa-0">
                                            <v-list-item-title>
                                                {{ $t('components.verify_mobile.form_body.radio_call_label') }}
                                            </v-list-item-title>
                                            <v-list-item-subtitle class="text-wrap">
                                                {{ $t('components.verify_mobile.form_body.radio_call_hint') }}
                                            </v-list-item-subtitle>

                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-radio>
                          <v-radio class="mb-0" value="email" v-if="isTokenLogin && $store.state.auth.maskedEmail">
                            <template slot="label">
                              <v-list-item class="pa-0" two-line>
                                <v-list-item-content class="pa-0">
                                  <v-list-item-title>
                                    {{ $t('components.verify_mobile.form_body.radio_email_label') }}
                                  </v-list-item-title>
                                  <v-list-item-subtitle class="text-wrap">
                                    {{ $t('components.verify_mobile.form_body.radio_email_hint') }}
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                          </v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
            </v-form>
          <small>
            {{ $t('components.terms.login') }} <a @click="visitTerms()">{{ $t('components.terms.review') }}.</a>
          </small>
        </v-card-text>
        <v-card-actions class="pb-4 px-4 pt-0">
            <v-row no-gutters>
                <v-col cols="12">
                    <v-row no-gutters flex-no-wrap justify="space-between">
                        <v-btn :dark="!loading"
                               :disabled="loading"
                               @click="emitBack()"
                               color="grey"
                               large
                               v-if="!register"
                        >{{ withToken ? $t('general.back') : $t('general.quit') }}
                        </v-btn>
                        <v-btn :disabled="!mobileVerificationFormIsValid"
                               :loading="loading"
                               @click="emitLogin()"
                               color="primary"
                               large
                        >{{ $t('general.verify') }}
                        </v-btn>
                      <v-spacer></v-spacer>
                       <v-btn text @click="useEmail()" color="secondary" v-if="!isTokenLogin">
                         {{$t('components.verify_mobile.use_email')}}
                       </v-btn>
                    </v-row>
                </v-col>

            </v-row>
        </v-card-actions>
    </v-card>
</template>

<script>
    import CountrySelect from "../framework/general/CountrySelect";
    import PageHeading from "../framework/PageHeading";

    export default {
        components: {
            CountrySelect,
            PageHeading
        },
        props: {
            value: {
                type: Object,
                default: null
            },
            loading: {
                type: Boolean,
                default: false
            },
            errors: {
                type: Array,
                default: () => []
            },
            pageTranslationText: {
                required: true,
                type: Object
            },
            isTokenLogin: {
                type: Boolean,
                default: false
            },
            register: {
                type: Boolean
            }
        },
        watch: {
          via(){
            this.$emit('optionChanged',this.via);
          }
        },
        data: () => ({
            code: null,
            mobileVerificationFormIsValid: false,
            via: 'sms',
            withToken: false,
            whatsAppEnabled: false
        }),
        methods: {
            emitLogin() {
                if (this.$refs.mobileVerificationForm.validate()) {
                    this.$emit('login', this.via);
                }
            },
            emitBack() {
                this.$emit('back');
            },
            isNumber(evt) {
                let charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) || charCode === 46) {
                    evt.preventDefault();
                } else if (evt.key < 0 || evt.key > 9) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            useEmail() {
                this.$emit('goto', 'email');
            },
            visitTerms(){
              window.open('https://fitt.ai/privacy','_blank');
            }
        },
        mounted() {
            this.withToken = location.hash.includes('token');
            if(!this.$store.state.auth.maskedMobile){
                this.via='email';
            }
        }
    }
</script>

<style>

</style>
